import React from "react";
import { Link, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { ReactComponent as Close } from "../../assets/images/close.svg";
import AuthHelper from "../../utils/AuthHelper";
import RoseButton from "../common/RoseButton";
import { sendCtaClickLandingPageGTM } from "../../utils/TagManagerHelper";

function LandingPopUpModal({ setShow }) {
  const location = useLocation();

  const handleRegister = (ctaName) => {
    AuthHelper.register();
    sendCtaClickLandingPageGTM(ctaName, `[overlay]-${location.pathname}`);
  };

  const handleLogin = () => {
    AuthHelper.login();
    sendCtaClickLandingPageGTM("Log in", `[overlay]-${location.pathname}`);
  };

  return (
    <div className="landing-popup">
      <div className="popup-cta">
        <div className="float-right">
          <Close width="18" height="18" className="cursor-pointer" onClick={() => setShow(false)} />
        </div>
        <div className="cta-wrap">
          <div className="cta-text">
            <h4 className="medium-contrast">Are you a Reply customer?</h4>
            <p className="light-contrast mb-0">Redeem access to join ROSE.</p>
          </div>
          <div className="btns-wrap">
            <RoseButton className="big-cta primary-cta btn-1" onClick={handleLogin}>
              Log in
            </RoseButton>
            <RoseButton
              className="big-cta ask-rose-cta"
              onClick={() => handleRegister("Get your membership")}
            >
              Get <span className="hide-text">your</span> <span className="show-text">a</span>{" "}
              membership
            </RoseButton>
          </div>
        </div>
        <div className="popup-request">
          <p className="h7 medium-contrast mb-0">
            If you are not currently a <br /> Reply customer&nbsp;
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <Link
              to="#"
              className="h7 link-line"
              onClick={() => handleRegister("send us your request")}
            >
              send us your request
            </Link>
            &nbsp;to join ROSE.
          </p>
        </div>
      </div>
    </div>
  );
}

LandingPopUpModal.propTypes = {
  setShow: PropTypes.func.isRequired,
};

export default LandingPopUpModal;
